<div class="container-fluid">
	<div class="row align-items-end my-3">
		<div class="col">
			<h1 class="text-capitalize">Seleccionar Impresora</h1>
			<p class="text-muted mb-0">Configure que impresora usar en este dispositivo</p>
		</div>
		<div class="col-auto">
			<button type="button" class="btn btn-secondary" [routerLink]="['/list-printer-config']">Ver todas</button>
		</div>
	</div>

	<app-loading [is_loading]="is_loading"></app-loading>

	<div class="row" *ngIf="!is_loading">
		<!-- Print Method Selection -->
		<div class="col-12 col-lg-6 mb-4">
			<div class="card">
				<div class="card-header">
					<h5 class="card-title mb-0">Metodo de Impresion</h5>
				</div>
				<div class="card-body">
					<div class="form-check mb-3">
						<input class="form-check-input" type="radio" name="print_method" id="method_browser"
							value="BROWSER" [(ngModel)]="preferences.print_method" (change)="onPrintMethodChange()">
						<label class="form-check-label" for="method_browser">
							<strong>Navegador</strong>
							<span class="d-block text-muted small">Usa la impresion estandar del navegador (window.print)</span>
						</label>
					</div>
					<div class="form-check">
						<input class="form-check-input" type="radio" name="print_method" id="method_usb"
							value="USB" [(ngModel)]="preferences.print_method" (change)="onPrintMethodChange()">
						<label class="form-check-label" for="method_usb">
							<strong>USB Directo</strong>
							<span class="d-block text-muted small">Impresion directa a impresora termica USB (WebUSB)</span>
						</label>
					</div>
				</div>
			</div>
		</div>

		<!-- POS Printer Selection -->
		<div class="col-12 col-lg-6 mb-4" *ngIf="preferences.print_method === 'USB'">
			<div class="card">
				<div class="card-header">
					<h5 class="card-title mb-0">Impresora POS (Recibos)</h5>
				</div>
				<div class="card-body">
					<div *ngIf="printer_list.length === 0" class="alert alert-warning">
						No hay impresoras configuradas.
						<a [routerLink]="['/add-printer-config']">Agregar una impresora</a>
					</div>

					<div *ngIf="printer_list.length > 0">
						<div class="mb-3">
							<label class="form-label">Seleccionar impresora para recibos:</label>
							<select class="form-select" [(ngModel)]="preferences.pos_printer_id" (change)="onPosPrinterChange()">
								<option [ngValue]="null">-- Ninguna --</option>
								<option *ngFor="let printer of printer_list" [ngValue]="printer.id">
									{{ printer.name }}
								</option>
							</select>
						</div>

						<!-- Selected printer info and test -->
						<div *ngIf="preferences.pos_printer_id" class="border rounded p-3 bg-light">
							<ng-container *ngFor="let printer of printer_list">
								<div *ngIf="printer.id === preferences.pos_printer_id">
									<div class="d-flex justify-content-between align-items-center">
										<div>
											<strong>{{ printer.name }}</strong>
										</div>
										<button class="btn btn-sm btn-outline-primary" (click)="testConnection(printer, $event)"
											[disabled]="test_status.get(printer.id) === 'testing'">
											<span *ngIf="test_status.get(printer.id) === 'testing'">Probando...</span>
											<span *ngIf="test_status.get(printer.id) !== 'testing'">Probar conexion</span>
										</button>
									</div>
									<div class="small text-muted mt-1">
										Modelo: {{ printer.model }} | Sucursal: {{ getStoreName(printer.store_id) }}
									</div>
									<div *ngIf="test_messages.get(printer.id)" class="mt-2" [ngClass]="getTestStatusClass(printer.id)">
										{{ test_messages.get(printer.id) }}
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Kitchen Printers Selection -->
		<div class="col-12 mb-4" *ngIf="preferences.print_method === 'USB'">
			<div class="card">
				<div class="card-header">
					<h5 class="card-title mb-0">Impresoras de Cocina (Comandas)</h5>
					<span class="text-muted small">Puede seleccionar multiples impresoras</span>
				</div>
				<div class="card-body">
					<div *ngIf="printer_list.length === 0" class="alert alert-warning">
						No hay impresoras configuradas.
						<a [routerLink]="['/add-printer-config']">Agregar una impresora</a>
					</div>

					<div *ngIf="printer_list.length > 0" class="table-responsive">
						<table class="table table-hover mb-0">
							<thead class="thead-light">
								<tr>
									<th style="width: 50px;">Usar</th>
									<th>Nombre</th>
									<th class="d-none d-md-table-cell">Modelo</th>
									<th style="width: 150px;">Estado</th>
									<th style="width: 120px;">Accion</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let selection of kitchen_selections">
									<td>
										<input class="form-check-input" type="checkbox"
											[(ngModel)]="selection.selected" (change)="onKitchenPrinterChange(selection)">
									</td>
									<td>{{ selection.printer.name }}</td>
									<td class="d-none d-md-table-cell">{{ selection.printer.model }}</td>
									<td>
										<span [ngClass]="getTestStatusClass(selection.printer.id)">
											{{ test_messages.get(selection.printer.id) || 'Sin probar' }}
										</span>
									</td>
									<td>
										<button class="btn btn-sm btn-outline-primary" (click)="testConnection(selection.printer, $event)"
											[disabled]="test_status.get(selection.printer.id) === 'testing'">
											Probar
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		<!-- Current Configuration Summary -->
		<div class="col-12">
			<div class="card border-primary">
				<div class="card-header bg-primary text-white">
					<h5 class="card-title mb-0">Configuracion Actual</h5>
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-md-4">
							<strong>Metodo:</strong>
							<span class="badge" [ngClass]="preferences.print_method === 'USB' ? 'bg-success' : 'bg-secondary'">
								{{ preferences.print_method === 'USB' ? 'USB Directo' : 'Navegador' }}
							</span>
						</div>
						<div class="col-md-4" *ngIf="preferences.print_method === 'USB'">
							<strong>Impresora POS:</strong>
							<span [class.text-muted]="!preferences.pos_printer_id">
								{{ getPrinterName(preferences.pos_printer_id) }}
							</span>
						</div>
						<div class="col-md-4" *ngIf="preferences.print_method === 'USB'">
							<strong>Cocina:</strong>
							<span *ngIf="preferences.kitchen_printer_ids.length > 0">
								{{ preferences.kitchen_printer_ids.length }} impresora(s)
							</span>
							<span *ngIf="preferences.kitchen_printer_ids.length === 0" class="text-muted">Ninguna</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
